import React, {useState} from "react";

import ElasticsearchAPIConnector from "@elastic/search-ui-elasticsearch-connector";

import {
  ErrorBoundary,
  Facet,
  SearchProvider,
  SearchBox,
  Results,
  PagingInfo,
  ResultsPerPage,
  Paging,
  Sorting,
  WithSearch,
} from "@elastic/react-search-ui";
import "@elastic/react-search-ui-views/lib/styles/styles.css";
import {
  Layout,
  BooleanFacet,
  SingleSelectFacet,
  SingleLinksFacet,
} from "@elastic/react-search-ui-views";

import {
  buildAutocompleteQueryConfig,
  buildFacetConfigFromConfig,
  buildSearchOptionsFromConfig,
  buildSortOptionsFromConfig,
  getConfig,
  getFacetFields,
} from "./config/config-helper";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  TextField,
  Toolbar,
  Typography
} from "@mui/material";

const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();
const username = "swapstreet";
const password = "Swapstreet21!";
const connector = new ElasticsearchAPIConnector({
  host: "https://vwu0ceylo4.execute-api.us-east-1.amazonaws.com/dev",
  index: "maverick_dev",
  connectionOptions: {
    headers: {
      Authorization: `Basic ${btoa(username + ":" + password)}`,
    },
  },
});
const config = {
  searchQuery: {
    search_fields: {
      name: {
        weight: 3,
      },
      postalcode: {
        weight: 1,
      },
      city: {
        weight: 1,
      },
      // state: {},
    },
    result_fields: {
      name: {
        snippet: {},
      },
      state: {
        snippet: {},
      },
      sexualities: {},
      issues: {},
      city: {},
      postalcode: {},
      photo: {},
      degrees: {},
      statements: {},
      phone_number: {}
    },
    disjunctiveFacets: [
      "sexualities.keyword",
      "issues.keyword",
      "treatments.keyword",
      "state.keyword",
    ],
    facets: {
      "sexualities.keyword": { type: "value" },
      "issues.keyword": { type: "value" },
      "treatments.keyword": { type: "value" },
      "state.keyword": { type: "value" },
    },
  },
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true,
};

function ProviderCard(props) {
  const {provider} = props;

  const [isHover, setIsHover] = useState(false);

  return <Paper onMouseOver={() => {setIsHover(true)}} onMouseOut={() => {setIsHover(false)}} elevation={isHover ? 3 : 0} sx={{p: 3, mb: 3}}>
    <Grid container columnSpacing={2}>
      <Grid item auto>
        <Avatar
            alt={provider.name.raw}
            src={provider?.photo?.raw}
            sx={{ width: 157, height: 196 }}
            variant="square"
        />
      </Grid>
      <Grid item xs>
        <Typography color={"#477BE4"} fontSize={26}>{provider.name.raw}</Typography>
        <Typography color={"#2C2D30"} fontSize={15}>{provider?.degrees.raw.map(txt => {return txt + " "} )}</Typography>
        <div style={{maxHeight: 150, overflow: "hidden"}}>
          {provider?.statements?.raw?.map(statement => {return <p><Typography color={"#2C2D30"} fontSize={17}>{statement}</Typography></p>})}
        </div>
      </Grid>
      <Grid item xs={3}>
        <Typography sx={{mt: 1, mb: 1}} color={"#2C2D30"} fontSize={21}>{provider?.phone_number.raw}</Typography>
        <Divider/>
        <Typography sx={{mt: 1, mb: 2}} color={"#2C2D30"} fontSize={15}>{provider?.city?.raw}, {provider?.state.raw[0]}  {provider?.postalcode?.raw}</Typography>
        <Button sx={{mt: 3}} fullWidth variant="contained" color={"secondary"}>More Details</Button>
        <Button sx={{mt: 1}} fullWidth variant="contained">Schedule Now</Button>
      </Grid>
    </Grid>

  </Paper>
}

const CustomResultView = ({ result, onClickLink }) => (
  <li>
    <ProviderCard provider={result}/>
  </li>
);

export default function App() {
  return (
    <SearchProvider config={config}>
      <WithSearch mapContextToProps={({ wasSearched }) => ({ wasSearched })}>
        {({ wasSearched }) => {
          return (
              <>
              <AppBar position="static">
                <Container maxWidth="lg">
                  <Toolbar disableGutters>
                    <Typography sx={{mr: 1}} fontSize={26}>BetterPathVT</Typography>
                    {/*<Box sx={{ flexGrow: 1, display: {md: 'flex' } }}>*/}
                    {/*  <SearchBox*/}
                    {/*      inputView={({ getAutocomplete, getInputProps, getButtonProps }) => (*/}
                    {/*          <>*/}
                    {/*            <TextField sx={{backgroundColor: "white", width: 800}}*/}
                    {/*                       onBlur={getInputProps().onBlur} onChange={getInputProps().onChange} onFocus={getInputProps().onFocus} onKeyDown={getInputProps().onKeyDown}*/}
                    {/*            value={getInputProps().value} placeholder={"Search"}/>*/}

                    {/*            {getAutocomplete()}*/}
                    {/*            {console.log(getInputProps())}*/}
                    {/*            <Button*/}
                    {/*                type={"submit"}*/}
                    {/*                color={"secondary"}*/}
                    {/*                variant={"contained"}*/}

                    {/*            >Search</Button>*/}
                    {/*          </>*/}
                    {/*      )}*/}
                    {/*  />*/}
                    {/*</Box>*/}

                  </Toolbar>
                </Container>
              </AppBar>
                <Box sx={{py: 2, backgroundColor: "#F5F7F9"}}>
                  <Container sx={{mt: 2, mb: 2}} maxWidth="lg">
                  <SearchBox inputProps={{ placeholder: "City, Zip, or Name" }}/>
                  </Container>
                </Box>
              <Container sx={{mt: 1, mb: 2}} maxWidth="lg">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                  </Grid>
                  <Grid item xs={3}>
                    <div>
                      {wasSearched && (
                          <Sorting
                              label={"Sort by"}
                              sortOptions={[
                                {
                                  name: "Provider Name",
                                  value: [
                                    { field: "name.keyword", direction: "asc" },
                                  ],
                                },
                                {
                                  name: "City",
                                  value: [
                                    { field: "city.keyword", direction: "desc" },
                                  ],
                                },
                                {
                                  name: "Zipcode",
                                  value: [
                                    {
                                      field: "postalcode.keyword",
                                      direction: "desc",
                                    },
                                  ],
                                },
                              ]}
                          />
                      )}
                      <Facet
                          key={"1"}
                          field={"state.keyword"}
                          label={"state"}
                          view={SingleSelectFacet}
                      />
                      <Facet
                          key={"5"}
                          field={"status.keyword"}
                          label={"status"}
                      />
                      <Facet
                          key={"4"}
                          field={"sexualities.keyword"}
                          label={"sexualities"}
                      />
                      <Facet
                          key={"2"}
                          field={"issues.keyword"}
                          label={"issues"}
                      />
                      <Facet
                          key={"3"}
                          field={"treatments.keyword"}
                          label={"treatments"}
                      />

                      {/* <Facet
                        key={"4"}
                        field={"imdbRating"}
                        label={"imdb rating"}
                      /> */}
                    </div>
                  </Grid>
                  <Grid item xs={9}>
                    <Grid container>
                      <Grid item xs={12}>
                        <React.Fragment>
                          {wasSearched && <PagingInfo />}
                          {wasSearched && <ResultsPerPage />}
                        </React.Fragment>
                      </Grid>
                    </Grid>
                    <Results
                        resultView={CustomResultView}
                        shouldTrackClickThrough={true}
                    />
                    <Paging />
                  </Grid>
                </Grid>
              </Container>
            {/*<div className="App">*/}
            {/*  <ErrorBoundary>*/}
            {/*    <Layout*/}
            {/*      header={<SearchBox />}*/}
            {/*      sideContent={*/}
            {/*        <div>*/}
            {/*          {wasSearched && (*/}
            {/*            <Sorting*/}
            {/*              label={"Sort by"}*/}
            {/*              sortOptions={[*/}
            {/*                {*/}
            {/*                  name: "Provider Name",*/}
            {/*                  value: [*/}
            {/*                    { field: "name.keyword", direction: "asc" },*/}
            {/*                  ],*/}
            {/*                },*/}
            {/*                {*/}
            {/*                  name: "City",*/}
            {/*                  value: [*/}
            {/*                    { field: "city.keyword", direction: "desc" },*/}
            {/*                  ],*/}
            {/*                },*/}
            {/*                {*/}
            {/*                  name: "Zipcode",*/}
            {/*                  value: [*/}
            {/*                    {*/}
            {/*                      field: "postalcode.keyword",*/}
            {/*                      direction: "desc",*/}
            {/*                    },*/}
            {/*                  ],*/}
            {/*                },*/}
            {/*              ]}*/}
            {/*            />*/}
            {/*          )}*/}
            {/*          <Facet*/}
            {/*            key={"1"}*/}
            {/*            field={"state.keyword"}*/}
            {/*            label={"state"}*/}
            {/*            view={SingleSelectFacet}*/}
            {/*          />*/}
            {/*          <Facet*/}
            {/*            key={"5"}*/}
            {/*            field={"status.keyword"}*/}
            {/*            label={"status"}*/}
            {/*          />*/}
            {/*          <Facet*/}
            {/*            key={"4"}*/}
            {/*            field={"sexualities.keyword"}*/}
            {/*            label={"sexualities"}*/}
            {/*          />*/}
            {/*          <Facet*/}
            {/*            key={"2"}*/}
            {/*            field={"issues.keyword"}*/}
            {/*            label={"issues"}*/}
            {/*          />*/}
            {/*          <Facet*/}
            {/*            key={"3"}*/}
            {/*            field={"treatments.keyword"}*/}
            {/*            label={"treatments"}*/}
            {/*          />*/}

            {/*          /!* <Facet*/}
            {/*            key={"4"}*/}
            {/*            field={"imdbRating"}*/}
            {/*            label={"imdb rating"}*/}
            {/*          /> *!/*/}
            {/*        </div>*/}
            {/*      }*/}
            {/*      bodyContent={*/}
            {/*        <Results*/}
            {/*          resultView={CustomResultView}*/}
            {/*          shouldTrackClickThrough={true}*/}
            {/*        />*/}
            {/*      }*/}
            {/*      bodyHeader={*/}
            {/*        <React.Fragment>*/}
            {/*          {wasSearched && <PagingInfo />}*/}
            {/*          {wasSearched && <ResultsPerPage />}*/}
            {/*        </React.Fragment>*/}
            {/*      }*/}
            {/*      bodyFooter={<Paging />}*/}
            {/*    />*/}
            {/*  </ErrorBoundary>*/}
            {/*</div>*/}
              </>);
        }}
      </WithSearch>
    </SearchProvider>)
}
